import styled from "styled-components";

export const PopupContainer = styled.div`
    position: absolute;
    right: 24px;
    top: 24px;
`;
